import { createSlice } from "@reduxjs/toolkit";
import { initialState } from "../initialState.js";
import {
  getCams,
  switchCam,
  createCam,
  updateCam,
  deleteCam,
} from "./operations.js";

const videoSlice = createSlice({
  name: "video",
  initialState: initialState.video,
  reducer: {},
  extraReducers: builder =>
    builder
      .addCase(getCams.pending, (state, action) => {
        state.isCameraLoading = true;
        state.errorCamera = null;
      })
      .addCase(getCams.fulfilled, (state, action) => {
        state.isCameraLoading = false;
        state.errorCamera = null;
        state.cameras = action.payload;
      })
      .addCase(getCams.rejected, (state, action) => {
        state.isCameraLoading = false;
        state.errorCamera = action.payload;
      })

      .addCase(switchCam.pending, (state, action) => {
        state.isCameraLoading = true;
        state.errorCamera = null;
      })
      .addCase(switchCam.fulfilled, (state, action) => {
        state.isCameraLoading = false;
        state.errorCamera = null;
        state.cameras = state.cameras.map(cam =>
          cam.id === action.payload.id
            ? { ...cam, rec_status: action.payload.rec_status }
            : cam
        );
      })
      .addCase(switchCam.rejected, (state, action) => {
        state.isCameraLoading = false;
        state.errorCamera = action.payload;
      })

      .addCase(createCam.pending, (state, action) => {
        state.isCameraLoading = true;
        state.errorCamera = null;
      })
      .addCase(createCam.fulfilled, (state, action) => {
        state.isCameraLoading = false;
        state.errorCamera = null;
        state.cameras.push(action.payload);
      })
      .addCase(createCam.rejected, (state, action) => {
        state.isCameraLoading = false;
        state.errorCamera = action.payload;
      })

      .addCase(updateCam.pending, (state, action) => {
        state.isCameraLoading = true;
        state.errorCamera = null;
      })
      .addCase(updateCam.fulfilled, (state, action) => {
        state.isCameraLoading = false;
        state.errorCamera = null;
        state.cameras = state.cameras.map(cam =>
          cam.id === action.payload.id ? action.payload : cam
        );
      })
      .addCase(updateCam.rejected, (state, action) => {
        state.isCameraLoading = false;
        state.errorCamera = action.payload;
      })

      .addCase(deleteCam.pending, (state, action) => {
        state.isCameraLoading = true;
        state.errorCamera = null;
      })
      .addCase(deleteCam.fulfilled, (state, action) => {
        state.isCameraLoading = false;
        state.errorCamera = null;
        state.cameras = state.cameras.filter(
          cam => cam.id !== action.payload.camId
        );
      })
      .addCase(deleteCam.rejected, (state, action) => {
        state.isCameraLoading = false;
        state.errorCamera = action.payload;
      }),
});

export default videoSlice.reducer;
